import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { message } from '../../../utils/stringUtils';
import { appConfig } from '../../../config/customization';
import Images from '../../../config/assets';

import styles from './styles';

const errorPng = Images.errorCactus;
const noElementsPng = Images.errorNoElements;
const timerPng = Images.errorTimer;

const images = { errorPng, noElementsPng, timerPng };
const variants = ['error', 'noElements', 'timer'];
const variantsStyle = ['totalHeight'];

function UTErrorScreen({ mssg, ...props }) {
  const image = variants.filter(variant => props[variant]).map(variant => images[`${variant}Png`]);
  const alt = variants.filter(variant => props[variant]).map(variant => message(`ErrorScreen:${variant}`));
  const style = variantsStyle.filter(variant => props[variant]).map(variant => styles[variant]);

  return (
    <div style={[styles.container, props.style, style]}>
      {appConfig.errorScreenWithImage && (
        <img alt={alt} src={image} style={[styles.image, props.imageStyle]} />
      )}
      <div style={[styles.informationContainer, props.labelStyle]}>
        <UTLabel xlarge bold>
          {mssg}
        </UTLabel>
      </div>
    </div>
  );
}

UTErrorScreen.defaultProps = {
  mssg: message('ErrorScreen:noItemsError')
};

UTErrorScreen.propTypes = {
  mssg: PropTypes.string,
  imageStyle: PropTypes.any, // eslint-disable-line react/forbid-prop-types,
  labelStyle: PropTypes.any // eslint-disable-line react/forbid-prop-types
};

export default Radium(UTErrorScreen);
